export const PACKAGE_NAME = 'jira-business.empty-view';
export const JWM_INTRO_ANIMATION_IMAGE_WIDTH = 400;
export const JWM_INTRO_ANIMATION_IMAGE_HEIGHT = 380;
